import classNames from 'classnames';
import { BlockInvalidFieldsCount } from 'components/common-form/builder/form/node/block/components/BlockInvalidFieldsCount';
import type { IntlKey } from 'locales';
import { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';

type BlockProps<IdType extends string = string> = {
  children: ReactNode;
  id: string;
  fieldIds: readonly IdType[];
  label: IntlKey;
  className?: string;
};

export const Block: FC<BlockProps> = ({ label, children, id, fieldIds, className }) => {
  const { formatMessage } = useIntl();

  return (
    <div id={id} className={classNames('card h-100 bg-lvl1 shadow-sm', className)}>
      <div className="card-body">
        <h5 className="card-title d-flex align-items-center">
          {formatMessage({ id: label })}
          <BlockInvalidFieldsCount blockId={id} fieldIds={fieldIds} errorPrefix="secondaryMarket.form.errors." />
        </h5>
        <div className="card-text">{children}</div>
      </div>
    </div>
  );
};
